import React, { useState, useEffect } from 'react';
//Components
import PopUp from './PopUp';
import GeneralEdit from './GeneralEdit';
import TipoEdit from './TipoEdit';
import LevantarNotificarEdit from './LevantarNotificarEdit';
//Material-UI
import { Button } from '@material-ui/core';
//Icons
import { Edit } from 'tabler-icons-react';
//Context
import { useLlamadas } from './LlamadasContext';

function EditarTipoLlamada() {
    const { step, setStep, setEditar, isEdit, putCallType, theCallType, setNewCallType, clear, newCallType } = useLlamadas();

    const isStepValid = step === 0 ? !!newCallType?.nombre?.trim() : true;
    const [primaryButton, setPrimaryButton] = useState('Siguiente');
    const [secondaryBtn, setSecondaryBtn] = useState('Cancelar');

    const increment = (e) => {
        e.preventDefault();
        if (step < 2) setStep(step + 1);
        else putCallType();
    };

    const secondAction = () => {
        if (step > 0) setStep(step - 1);
        else { setEditar(false); clear(); }
    };

    useEffect(() => {
        setSecondaryBtn(step > 0 ? 'Atrás' : 'Cancelar');
        setPrimaryButton(step > 1 ? 'Finalizar' : 'Siguiente');
    }, [step]);

    useEffect(() => {
        setNewCallType(theCallType);
    }, [setNewCallType, theCallType]);

    const stepContent =
        step === 0 ? <GeneralEdit /> :
        step === 1 ? <TipoEdit /> :
                     <LevantarNotificarEdit />;

    const footer = (
        <>
            <Button variant="outlined" color="primary" className="popup-button-s" onClick={secondAction}>
                {secondaryBtn}
            </Button>
            <Button variant="contained" color="primary" className="popup-button-s" onClick={increment} disabled={!isStepValid}>
                {primaryButton}
            </Button>
        </>
    );

    return (
        <PopUp
            name="editar"
            buttonClass="actions-edit"
            colorButton="default"
            isContained="text"
            isActive={isEdit}
            hideTrigger
            textButton={<span className="llamada-btn-content"><Edit size={18} /> Editar</span>}
            title="Editar Tipo de Llamada"
            popupBody={stepContent}
            popupFooter={footer}
        />
    );
}

export default EditarTipoLlamada;
